import { get } from 'lodash';
import { createSelector } from 'reselect';

import getOuterUrl from '../services/get-outer-url';

const getItems = state => get(state, 'locationHistory.items');
export const getCount = state => get(getItems(state), 'count', 0);
export const isInitialLocation = state => getCount(state) === 1;
export const getCurrentLocation = createSelector(getItems, items => items && items[items.length - 1]);
export const getPreviousLocation = createSelector(getItems, items => items && items[items.length - 2]);
export const getCurrentLocationOuterUrl = state =>
  getCurrentLocation(state) && getOuterUrl(getCurrentLocation(state).pathname);



// WEBPACK FOOTER //
// ./app/selectors/location-history-selectors.js